import { useCallback } from 'react';
import { useNavigationGuard } from '../../../../../../hooks/use-navigation-guard';
export const useHandleUnsavedChangesOnToggle = (openItems, setOpenItems, afterNavigate, unsavedChangesHandlers) => {
  const {
    guardNavigation
  } = useNavigationGuard(unsavedChangesHandlers);
  return useCallback(value => {
    const newOpenItems = typeof value === 'function' ? value(openItems) : value;
    const currentItems = Array.from(openItems);
    const newItems = Array.from(newOpenItems);
    const currentItem = currentItems.length > 0 ? currentItems[0] : undefined;
    const newItem = newItems.length > 0 ? newItems[0] : undefined;
    if (newItem !== currentItem && currentItem !== undefined) {
      guardNavigation(() => {
        setOpenItems(newOpenItems);
        afterNavigate == null || afterNavigate();
      });
    } else {
      setOpenItems(newOpenItems);
      afterNavigate == null || afterNavigate();
    }
  }, [openItems, guardNavigation, setOpenItems, afterNavigate]);
};
//# sourceMappingURL=use-handle-unsaved-changes-on-toggle.js.map